/**
 * @deprecated Previous Stripe return pages for room payments. Kept as an example of how
 * we handled success/cancel redirects via `paymentRoomId`. Routes remain registered to
 * match server StripePay URLs; the in-app wizard that started checkout was removed.
 * Do not delete — we may reuse this pattern.
 */
import { Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { Route } from "~services/router/Route";
import { valueOrFallback } from "~utils/sanitizeDto";

import { useSelector } from "../../hooks";

// Centralized strings for internationalization
const tReturnToRoom = "Return to the room";
const tReturnToHome = "Return to home";
const tPaymentProcessed = "Payment processed";
const tPaymentCancelled = "Payment cancelled";

const PaymentResult = ({ label }: { label: string }) => {
  const id = useSelector((state) => state.app.paymentRoomId);
  return (
    <>
      <Typography variant="h4">{label}</Typography>
      <br />
      {id ? (
        <Link
          to={Route.roomView({
            roomId: valueOrFallback(id, "MISSING_ID", "(PaymentResult) Missing state.app.paymentRoomId"),
          })}
        >
          <Button>{tReturnToRoom}</Button>
        </Link>
      ) : (
        <Link to={Route.home()}>
          <Button>{tReturnToHome}</Button>
        </Link>
      )}
    </>
  );
};

export const Success = () => <PaymentResult label={tPaymentProcessed} />;

export const Cancel = () => <PaymentResult label={tPaymentCancelled} />;
